import { createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card\"><div class=\"row align-items-center\"><div class=\"col-sm-6\"><h1 class=\"title\"> Project : ConvoRally team </h1><div class=\"breadcrumb-wrap mt-1 mb-2\"><nav aria-label=\"breadcrumb\"><ol class=\"breadcrumb mb-0\"><li class=\"breadcrumb-item\"><a href=\"#/dashboard\" class=\"\"><i class=\"fa fa-home\"></i> Home </a></li><li class=\"breadcrumb-item active\" aria-current=\"page\"><a href=\"javascript:void(0)\" class=\"breadcrumb-item active\">Project Name</a></li></ol></nav></div></div><div class=\"col-sm-6\"><div class=\"inline-items text-sm-right\"><ul><li><a href=\"#/dashboard\" class=\"btn default-btn\"><i class=\"fa fa-angle-left mr-1\"></i> Back </a></li><li><div class=\"file-actions position-relative ml-2 mt-1\"><div class=\"dropdown\"><a class=\"dropdown-toggle\" type=\"button\" id=\"dropdownMenuButton\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-ellipsis-h\"></i></a><div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"dropdownMenuButton\"><a class=\"dropdown-item\" href=\"javascript:void(0)\"><img src=\"img/icons/file-view.svg\" alt=\"\" class=\"mr-2 align-middle\"> View project details</a><a class=\"dropdown-item\" href=\"javascript:void(0)\"><img src=\"img/icons/eye.svg\" alt=\"\" class=\"mr-2 align-middle\"> View project gallery</a><a class=\"dropdown-item\" href=\"javascript:void(0)\"><img src=\"img/icons/pin.svg\" alt=\"\" class=\"mr-2 align-middle\"> Pin project</a></div></div></div></li></ul></div></div></div></div>", 1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card p-0" }, [
  /*#__PURE__*/_createVNode("div", { class: "bordered-tab-wrap" }, [
    /*#__PURE__*/_createVNode("ul", {
      class: "nav nav-tabs",
      id: "myTab",
      role: "tablist"
    }, [
      /*#__PURE__*/_createVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createVNode("button", {
          class: "nav-link active px-3",
          id: "chat-tab",
          "data-toggle": "tab",
          "data-target": "#chat",
          type: "button",
          role: "tab",
          "aria-controls": "chat",
          "aria-selected": "true"
        }, [
          /*#__PURE__*/_createVNode("i", { class: "far fa-comments mr-1" }),
          /*#__PURE__*/_createTextVNode(" Chat")
        ])
      ]),
      /*#__PURE__*/_createVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createVNode("button", {
          class: "nav-link px-3",
          id: "workflow-tab",
          "data-toggle": "tab",
          "data-target": "#workflow",
          type: "button",
          role: "tab",
          "aria-controls": "workflow",
          "aria-selected": "false"
        }, [
          /*#__PURE__*/_createVNode("i", { class: "fa fa-sitemap mr-1" }),
          /*#__PURE__*/_createTextVNode(" Workflow")
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "tab-content" }, [
      /*#__PURE__*/_createVNode("div", {
        class: "tab-pane active p-0 two-col-tab",
        id: "chat",
        role: "tabpanel",
        "aria-labelledby": "chat-tab"
      }, [
        /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-between" }, [
          /*#__PURE__*/_createVNode("div", { class: "left-col-wrap p-2 flex-grow-1 h-100 bg-white" }, [
            /*#__PURE__*/_createVNode("div", { class: "row align-items-center" }, [
              /*#__PURE__*/_createVNode("div", { class: "col-sm-4" }, [
                /*#__PURE__*/_createVNode("div", { class: "form-group mb-2 mb-sm-0" }, [
                  /*#__PURE__*/_createVNode("select", { class: "form-control" }, [
                    /*#__PURE__*/_createVNode("option", { value: "" }, "Search and select"),
                    /*#__PURE__*/_createVNode("option", { value: "" }, "option 1")
                  ])
                ])
              ]),
              /*#__PURE__*/_createVNode("div", { class: "col-sm-8" }, [
                /*#__PURE__*/_createVNode("div", { class: "inline-items text-sm-right align-middle" }, [
                  /*#__PURE__*/_createVNode("ul", null, [
                    /*#__PURE__*/_createVNode("li", null, [
                      /*#__PURE__*/_createVNode("div", {
                        class: "form-group control-with-icon mb-0 float-sm-right",
                        id: "projectStatus"
                      }, [
                        /*#__PURE__*/_createVNode("div", { class: "control-icon" }, [
                          /*#__PURE__*/_createVNode("i", { class: "fa fa-check" })
                        ]),
                        /*#__PURE__*/_createVNode("select", {
                          class: "form-control",
                          fdprocessedid: "zeithy"
                        }, [
                          /*#__PURE__*/_createVNode("option", { value: "active" }, "Active"),
                          /*#__PURE__*/_createVNode("option", { value: "closed" }, "Closed"),
                          /*#__PURE__*/_createVNode("option", { value: "hide" }, "Hide")
                        ])
                      ])
                    ]),
                    /*#__PURE__*/_createVNode("li", null, [
                      /*#__PURE__*/_createVNode("a", {
                        href: "javascript:void(0)",
                        class: "d-block create-url",
                        id: "343newChannel"
                      }, [
                        /*#__PURE__*/_createVNode("span", { class: "small-round-icon" }, [
                          /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
                        ]),
                        /*#__PURE__*/_createTextVNode(" Create Channel ")
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createVNode("div", { class: "accordion-wrap acc-v2" }, [
              /*#__PURE__*/_createVNode("div", {
                class: "accordion",
                id: "accordionExample"
              }, [
                /*#__PURE__*/_createVNode("div", { class: "mb-1" }, [
                  /*#__PURE__*/_createVNode("div", {
                    class: "card-header bg-white p-0 border-0",
                    id: "headingOne"
                  }, [
                    /*#__PURE__*/_createVNode("h2", { class: "mb-0" }, [
                      /*#__PURE__*/_createVNode("button", {
                        class: "btn btn-link btn-block text-left",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapseOne",
                        "aria-expanded": "true",
                        "aria-controls": "collapseOne"
                      }, [
                        /*#__PURE__*/_createVNode("i", { class: "far fa-comments text-green mr-2" }),
                        /*#__PURE__*/_createTextVNode(" Chat Channel (04) ")
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", {
                    id: "collapseOne",
                    class: "collapse show",
                    "aria-labelledby": "headingOne",
                    "data-parent": "#accordionExample"
                  }, [
                    /*#__PURE__*/_createVNode("div", { class: "card-body bg-light px-3" }, [
                      /*#__PURE__*/_createVNode("div", { class: "row mx-n2" }, [
                        /*#__PURE__*/_createVNode("div", { class: "col-lg-6 col-sm-6 px-2 mb-1nvm " }, [
                          /*#__PURE__*/_createVNode("div", { class: "kanban-wrap h-100" }, [
                            /*#__PURE__*/_createVNode("div", { class: "inner-small-wrap py-0 h-100" }, [
                              /*#__PURE__*/_createVNode("div", { class: "dragArea list-group w-full h-100" }, [
                                /*#__PURE__*/_createVNode("div", { class: "channel-card bg-white shadowed-box rounded h-100" }, [
                                  /*#__PURE__*/_createVNode("div", { class: "chat-card-header with-actiondropdown mb-1 mb-sm-3" }, [
                                    /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, [
                                      /*#__PURE__*/_createVNode("a", {
                                        href: "#/channel/2cd2e380-b518-4ea5-980e-1549d71e0767",
                                        class: "d-block"
                                      }, [
                                        /*#__PURE__*/_createTextVNode(" Channel : Bugs- Customer feedback Issues "),
                                        /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
                                          /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
                                        ]),
                                        /*#__PURE__*/_createVNode("span", { class: "notification-count-wrap" }, "62 unread message")
                                      ])
                                    ]),
                                    /*#__PURE__*/_createVNode("div", { class: "file-actions" }, [
                                      /*#__PURE__*/_createVNode("div", { class: "dropdown" }, [
                                        /*#__PURE__*/_createVNode("a", {
                                          class: "dropdown-toggle",
                                          type: "button",
                                          id: "dropdownMenuButton",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }, [
                                          /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
                                        ]),
                                        /*#__PURE__*/_createVNode("div", {
                                          class: "dropdown-menu dropdown-menu-right",
                                          "aria-labelledby": "dropdownMenuButton"
                                        }, [
                                          /*#__PURE__*/_createVNode("a", {
                                            class: "dropdown-item",
                                            href: "javascript:void(0)"
                                          }, [
                                            /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash mr-2" }),
                                            /*#__PURE__*/_createTextVNode(" Hide")
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "bg-light p-2 rounded mb-2 mt-sm-0 mt-2" }, [
                                    /*#__PURE__*/_createVNode("p", null, "Overall discussion"),
                                    /*#__PURE__*/_createVNode("p", null, [
                                      /*#__PURE__*/_createVNode("strong", null, "Status :"),
                                      /*#__PURE__*/_createVNode("span", { class: "active-status" }, "Active")
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("p", null, [
                                    /*#__PURE__*/_createVNode("small", null, [
                                      /*#__PURE__*/_createVNode("i", { class: "fas fa-user-clock text-green mr-1" }),
                                      /*#__PURE__*/_createTextVNode(" Steve Batts created 3 years ago")
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "row mx-n1 align-items-center" }, [
                                    /*#__PURE__*/_createVNode("div", { class: "col-sm-9 col-6 px-1" }, [
                                      /*#__PURE__*/_createVNode("div", { class: "members-list pt-0" }, [
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://app.convorally.com/storage/users/Alfa finshied jpg.jpg",
                                              alt: "",
                                              title: "Steve Batts(sbatts82@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://app.convorally.com/storage/users/anuj-imageb7fcaba0-70ae-4183-915f-a801f25c9180.jpg",
                                              alt: "",
                                              title: "Anuj Pandey(mysterymananuj@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://lh3.googleusercontent.com/a-/AFdZucqrdjZlQwfevvzj-HWj9utVJ1-OVqrAZEBerRRcIA=s96-c",
                                              alt: "",
                                              title: "Prabhu Chaudhary(creativevik7@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", { class: "more-member" }, "+6")
                                        ])
                                      ])
                                    ]),
                                    /*#__PURE__*/_createVNode("div", { class: "col-sm-3 col-6 text-right px-1" })
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "channel-information channel-member-addition" })
                                ])
                              ])
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("div", { class: "col-lg-6 col-sm-6 px-2 mb-1nvm " }, [
                          /*#__PURE__*/_createVNode("div", { class: "kanban-wrap h-100" }, [
                            /*#__PURE__*/_createVNode("div", { class: "inner-small-wrap py-0 h-100" }, [
                              /*#__PURE__*/_createVNode("div", { class: "dragArea list-group w-full h-100" }, [
                                /*#__PURE__*/_createVNode("div", { class: "channel-card bg-white shadowed-box rounded h-100" }, [
                                  /*#__PURE__*/_createVNode("div", { class: "chat-card-header with-actiondropdown mb-1 mb-sm-3" }, [
                                    /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, [
                                      /*#__PURE__*/_createVNode("a", {
                                        href: "#/channel/98fd2f6a-5775-41aa-8a3b-24c1e66b7c15",
                                        class: "d-block"
                                      }, [
                                        /*#__PURE__*/_createTextVNode(" Channel : Marketing & Video "),
                                        /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
                                          /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
                                        ])
                                      ])
                                    ]),
                                    /*#__PURE__*/_createVNode("div", { class: "file-actions" }, [
                                      /*#__PURE__*/_createVNode("div", { class: "dropdown" }, [
                                        /*#__PURE__*/_createVNode("a", {
                                          class: "dropdown-toggle",
                                          type: "button",
                                          id: "dropdownMenuButton",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }, [
                                          /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
                                        ]),
                                        /*#__PURE__*/_createVNode("div", {
                                          class: "dropdown-menu dropdown-menu-right",
                                          "aria-labelledby": "dropdownMenuButton"
                                        }, [
                                          /*#__PURE__*/_createVNode("a", {
                                            class: "dropdown-item",
                                            href: "javascript:void(0)"
                                          }, [
                                            /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash mr-2" }),
                                            /*#__PURE__*/_createTextVNode(" Hide")
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "bg-light p-2 rounded mb-2 mt-sm-0 mt-2" }, [
                                    /*#__PURE__*/_createVNode("p", null, "Discussions on marketing and video projects"),
                                    /*#__PURE__*/_createVNode("p", null, [
                                      /*#__PURE__*/_createVNode("strong", null, "Status :"),
                                      /*#__PURE__*/_createVNode("span", { class: "active-status" }, "Active")
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("p", null, [
                                    /*#__PURE__*/_createVNode("small", null, [
                                      /*#__PURE__*/_createVNode("i", { class: "fas fa-user-clock text-green mr-1" }),
                                      /*#__PURE__*/_createTextVNode("Steve Batts created 3 years ago")
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "row mx-n1 align-items-center" }, [
                                    /*#__PURE__*/_createVNode("div", { class: "col-sm-9 col-6 px-1" }, [
                                      /*#__PURE__*/_createVNode("div", { class: "members-list pt-0" }, [
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://app.convorally.com/storage/users/Alfa finshied jpg.jpg",
                                              alt: "",
                                              title: "Steve Batts(sbatts82@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://lh3.googleusercontent.com/a-/AFdZucpfUjeIPCXj2S8RtcmCwalTOef0Jw2njfEBzGwiFA=s96-c",
                                              alt: "",
                                              title: "Jeewan Thapa(jeewant@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://app.convorally.com/storage/users/WIN_20240219_10_24_28_Prod1b101b2-7c8f-4487-865b-fc74f9d94af9.jpg",
                                              alt: "",
                                              title: "Smurfy Basnyat(sajanabasnyat2008@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", { class: "more-member" }, "+2")
                                        ])
                                      ])
                                    ]),
                                    /*#__PURE__*/_createVNode("div", { class: "col-sm-3 col-6 text-right px-1" })
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "channel-information channel-member-addition" })
                                ])
                              ])
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("div", { class: "col-lg-6 col-sm-6 px-2 mb-1nvm " }, [
                          /*#__PURE__*/_createVNode("div", { class: "kanban-wrap h-100" }, [
                            /*#__PURE__*/_createVNode("div", { class: "inner-small-wrap py-0 h-100" }, [
                              /*#__PURE__*/_createVNode("div", { class: "dragArea list-group w-full h-100" }, [
                                /*#__PURE__*/_createVNode("div", { class: "channel-card bg-white shadowed-box rounded h-100" }, [
                                  /*#__PURE__*/_createVNode("div", { class: "chat-card-header with-actiondropdown mb-1 mb-sm-3" }, [
                                    /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, [
                                      /*#__PURE__*/_createVNode("a", {
                                        href: "#/channel/2cd2e380-b518-4ea5-980e-1549d71e0767",
                                        class: "d-block"
                                      }, [
                                        /*#__PURE__*/_createTextVNode(" Channel : Bugs- Customer feedback Issues "),
                                        /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
                                          /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
                                        ]),
                                        /*#__PURE__*/_createVNode("span", { class: "notification-count-wrap" }, "62 unread message")
                                      ])
                                    ]),
                                    /*#__PURE__*/_createVNode("div", { class: "file-actions" }, [
                                      /*#__PURE__*/_createVNode("div", { class: "dropdown" }, [
                                        /*#__PURE__*/_createVNode("a", {
                                          class: "dropdown-toggle",
                                          type: "button",
                                          id: "dropdownMenuButton",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }, [
                                          /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
                                        ]),
                                        /*#__PURE__*/_createVNode("div", {
                                          class: "dropdown-menu dropdown-menu-right",
                                          "aria-labelledby": "dropdownMenuButton"
                                        }, [
                                          /*#__PURE__*/_createVNode("a", {
                                            class: "dropdown-item",
                                            href: "javascript:void(0)"
                                          }, [
                                            /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash mr-2" }),
                                            /*#__PURE__*/_createTextVNode(" Hide")
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "bg-light p-2 rounded mb-2 mt-sm-0 mt-2" }, [
                                    /*#__PURE__*/_createVNode("p", null, "Overall discussion"),
                                    /*#__PURE__*/_createVNode("p", null, [
                                      /*#__PURE__*/_createVNode("strong", null, "Status :"),
                                      /*#__PURE__*/_createVNode("span", { class: "active-status" }, "Active")
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("p", null, [
                                    /*#__PURE__*/_createVNode("small", null, [
                                      /*#__PURE__*/_createVNode("i", { class: "fas fa-user-clock text-green mr-1" }),
                                      /*#__PURE__*/_createTextVNode(" Steve Batts created 3 years ago")
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "row mx-n1 align-items-center" }, [
                                    /*#__PURE__*/_createVNode("div", { class: "col-sm-9 col-6 px-1" }, [
                                      /*#__PURE__*/_createVNode("div", { class: "members-list pt-0" }, [
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://app.convorally.com/storage/users/Alfa finshied jpg.jpg",
                                              alt: "",
                                              title: "Steve Batts(sbatts82@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://app.convorally.com/storage/users/anuj-imageb7fcaba0-70ae-4183-915f-a801f25c9180.jpg",
                                              alt: "",
                                              title: "Anuj Pandey(mysterymananuj@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://lh3.googleusercontent.com/a-/AFdZucqrdjZlQwfevvzj-HWj9utVJ1-OVqrAZEBerRRcIA=s96-c",
                                              alt: "",
                                              title: "Prabhu Chaudhary(creativevik7@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", { class: "more-member" }, "+6")
                                        ])
                                      ])
                                    ]),
                                    /*#__PURE__*/_createVNode("div", { class: "col-sm-3 col-6 text-right px-1" })
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "channel-information channel-member-addition" })
                                ])
                              ])
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("div", { class: "col-lg-6 col-sm-6 px-2 mb-1" }, [
                          /*#__PURE__*/_createVNode("div", { class: "kanban-wrap h-100" }, [
                            /*#__PURE__*/_createVNode("div", { class: "inner-small-wrap py-0 h-100" }, [
                              /*#__PURE__*/_createVNode("div", { class: "dragArea list-group w-full h-100" }, [
                                /*#__PURE__*/_createVNode("div", { class: "channel-card bg-white shadowed-box rounded h-100" }, [
                                  /*#__PURE__*/_createVNode("div", { class: "chat-card-header with-actiondropdown mb-1 mb-sm-3" }, [
                                    /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, [
                                      /*#__PURE__*/_createVNode("a", {
                                        href: "#/channel/98fd2f6a-5775-41aa-8a3b-24c1e66b7c15",
                                        class: "d-block"
                                      }, [
                                        /*#__PURE__*/_createTextVNode(" Channel : Marketing & Video "),
                                        /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
                                          /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
                                        ])
                                      ])
                                    ]),
                                    /*#__PURE__*/_createVNode("div", { class: "file-actions" }, [
                                      /*#__PURE__*/_createVNode("div", { class: "dropdown" }, [
                                        /*#__PURE__*/_createVNode("a", {
                                          class: "dropdown-toggle",
                                          type: "button",
                                          id: "dropdownMenuButton",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }, [
                                          /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
                                        ]),
                                        /*#__PURE__*/_createVNode("div", {
                                          class: "dropdown-menu dropdown-menu-right",
                                          "aria-labelledby": "dropdownMenuButton"
                                        }, [
                                          /*#__PURE__*/_createVNode("a", {
                                            class: "dropdown-item",
                                            href: "javascript:void(0)"
                                          }, [
                                            /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash mr-2" }),
                                            /*#__PURE__*/_createTextVNode(" Hide")
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "bg-light p-2 rounded mb-2 mt-sm-0 mt-2" }, [
                                    /*#__PURE__*/_createVNode("p", null, "Discussions on marketing and video projects"),
                                    /*#__PURE__*/_createVNode("p", null, [
                                      /*#__PURE__*/_createVNode("strong", null, "Status :"),
                                      /*#__PURE__*/_createVNode("span", { class: "active-status" }, "Active")
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("p", null, [
                                    /*#__PURE__*/_createVNode("small", null, [
                                      /*#__PURE__*/_createVNode("i", { class: "fas fa-user-clock text-green mr-1" }),
                                      /*#__PURE__*/_createTextVNode("Steve Batts created 3 years ago")
                                    ])
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "row mx-n1 align-items-center" }, [
                                    /*#__PURE__*/_createVNode("div", { class: "col-sm-9 col-6 px-1" }, [
                                      /*#__PURE__*/_createVNode("div", { class: "members-list pt-0" }, [
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://app.convorally.com/storage/users/Alfa finshied jpg.jpg",
                                              alt: "",
                                              title: "Steve Batts(sbatts82@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://lh3.googleusercontent.com/a-/AFdZucpfUjeIPCXj2S8RtcmCwalTOef0Jw2njfEBzGwiFA=s96-c",
                                              alt: "",
                                              title: "Jeewan Thapa(jeewant@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", null, [
                                            /*#__PURE__*/_createVNode("img", {
                                              src: "https://app.convorally.com/storage/users/WIN_20240219_10_24_28_Prod1b101b2-7c8f-4487-865b-fc74f9d94af9.jpg",
                                              alt: "",
                                              title: "Smurfy Basnyat(sajanabasnyat2008@gmail.com)"
                                            })
                                          ])
                                        ]),
                                        /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
                                          /*#__PURE__*/_createVNode("span", { class: "more-member" }, "+2")
                                        ])
                                      ])
                                    ]),
                                    /*#__PURE__*/_createVNode("div", { class: "col-sm-3 col-6 text-right px-1" })
                                  ]),
                                  /*#__PURE__*/_createVNode("div", { class: "channel-information channel-member-addition" })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
                        /*#__PURE__*/_createVNode("a", {
                          href: "",
                          class: "btn default-btn"
                        }, "Load more")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createVNode("div", { class: "mb-1" }, [
                  /*#__PURE__*/_createVNode("div", {
                    class: "card-header bg-white p-0 border-0",
                    id: "headingTwo"
                  }, [
                    /*#__PURE__*/_createVNode("h2", { class: "mb-0" }, [
                      /*#__PURE__*/_createVNode("button", {
                        class: "btn btn-link btn-block text-left collapsed",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapseTwo",
                        "aria-expanded": "false",
                        "aria-controls": "collapseTwo"
                      }, [
                        /*#__PURE__*/_createVNode("i", { class: "fa fa-lock text-green mr-2" }),
                        /*#__PURE__*/_createTextVNode(" Private Chat Channel (02) ")
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", {
                    id: "collapseTwo",
                    class: "collapse",
                    "aria-labelledby": "headingTwo",
                    "data-parent": "#accordionExample"
                  }, [
                    /*#__PURE__*/_createVNode("div", { class: "card-body bg-light px-3" }, " Some placeholder content for the second accordion panel. This panel is hidden by default. ")
                  ])
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createVNode("div", { class: "right-col-wrap flex-shrink-0 h-100 py-3" }, [
            /*#__PURE__*/_createVNode("div", { class: "vertical-nav text-center" }, [
              /*#__PURE__*/_createVNode("ul", null, [
                /*#__PURE__*/_createVNode("li", null, [
                  /*#__PURE__*/_createVNode("a", {
                    "data-coreui-toggle": "offcanvas",
                    href: "#offcanvasExample",
                    role: "button",
                    "aria-controls": "offcanvasExample"
                  }, [
                    /*#__PURE__*/_createVNode("i", { class: "fa fa-users" }),
                    /*#__PURE__*/_createTextVNode(),
                    /*#__PURE__*/_createVNode("span", { class: "d-block" }, "Members")
                  ])
                ]),
                /*#__PURE__*/_createVNode("li", null, [
                  /*#__PURE__*/_createVNode("a", {
                    "data-coreui-toggle": "offcanvas",
                    href: "#offcanvasExample2",
                    role: "button",
                    "aria-controls": "offcanvasExample2"
                  }, [
                    /*#__PURE__*/_createVNode("i", { class: "fa fa-history" }),
                    /*#__PURE__*/_createTextVNode(),
                    /*#__PURE__*/_createVNode("span", { class: "d-block" }, "History")
                  ])
                ]),
                /*#__PURE__*/_createVNode("li", null, [
                  /*#__PURE__*/_createVNode("a", {
                    "data-coreui-toggle": "offcanvas",
                    href: "#offcanvasExample3",
                    role: "button",
                    "aria-controls": "offcanvasExample3"
                  }, [
                    /*#__PURE__*/_createVNode("i", { class: "fa fa-copy" }),
                    /*#__PURE__*/_createTextVNode(),
                    /*#__PURE__*/_createVNode("span", { class: "d-block" }, "Latest Forms")
                  ])
                ]),
                /*#__PURE__*/_createVNode("li", null, [
                  /*#__PURE__*/_createVNode("a", {
                    "data-coreui-toggle": "offcanvas",
                    href: "#offcanvasExample4",
                    role: "button",
                    "aria-controls": "offcanvasExample4"
                  }, [
                    /*#__PURE__*/_createVNode("i", { class: "fa fa-share-alt" }),
                    /*#__PURE__*/_createTextVNode(),
                    /*#__PURE__*/_createVNode("span", { class: "d-block" }, "Share Members")
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createVNode("div", {
        class: "tab-pane px-0",
        id: "workflow",
        role: "tabpanel",
        "aria-labelledby": "workflow-tab"
      }, [
        /*#__PURE__*/_createVNode("div", { class: "vertical-tab-wrap" }, [
          /*#__PURE__*/_createVNode("div", { class: "row no-gutters" }, [
            /*#__PURE__*/_createVNode("div", { class: "col-3 h-100" }, [
              /*#__PURE__*/_createVNode("div", {
                class: "nav flex-column",
                id: "v-pills-tab",
                role: "tablist",
                "aria-orientation": "vertical"
              }, [
                /*#__PURE__*/_createVNode("button", {
                  class: "nav-link active",
                  id: "v-pills-tab1-tab",
                  "data-toggle": "pill",
                  "data-target": "#v-pills-tab1",
                  type: "button",
                  role: "tab",
                  "aria-controls": "v-pills-tab1",
                  "aria-selected": "true"
                }, "Job Estimation"),
                /*#__PURE__*/_createVNode("button", {
                  class: "nav-link",
                  id: "v-pills-tab2-tab",
                  "data-toggle": "pill",
                  "data-target": "#v-pills-tab2",
                  type: "button",
                  role: "tab",
                  "aria-controls": "v-pills-tab2",
                  "aria-selected": "false"
                }, "Smart Contract"),
                /*#__PURE__*/_createVNode("button", {
                  class: "nav-link",
                  id: "v-pills-tab3-tab",
                  "data-toggle": "pill",
                  "data-target": "#v-pills-tab3",
                  type: "button",
                  role: "tab",
                  "aria-controls": "v-pills-tab3",
                  "aria-selected": "false"
                }, "Workflow"),
                /*#__PURE__*/_createVNode("button", {
                  class: "nav-link",
                  id: "v-pills-tab4-tab",
                  "data-toggle": "pill",
                  "data-target": "#v-pills-tab4",
                  type: "button",
                  role: "tab",
                  "aria-controls": "v-pills-tab4",
                  "aria-selected": "false"
                }, "Invoice"),
                /*#__PURE__*/_createVNode("button", {
                  class: "nav-link",
                  id: "v-pills-tab5-tab",
                  "data-toggle": "pill",
                  "data-target": "#v-pills-tab5",
                  type: "button",
                  role: "tab",
                  "aria-controls": "v-pills-tab5",
                  "aria-selected": "false"
                }, "Payment")
              ])
            ]),
            /*#__PURE__*/_createVNode("div", { class: "col-9 h-100 border-left" }, [
              /*#__PURE__*/_createVNode("div", {
                class: "tab-content",
                id: "v-pills-tabContent"
              }, [
                /*#__PURE__*/_createVNode("div", {
                  class: "tab-pane fade show active border-0",
                  id: "v-pills-tab1",
                  role: "tabpanel",
                  "aria-labelledby": "v-pills-tab1-tab"
                }, [
                  /*#__PURE__*/_createVNode("div", { class: "row align-items-center" }, [
                    /*#__PURE__*/_createVNode("div", { class: "col-sm-8 col-md-6" }, [
                      /*#__PURE__*/_createVNode("div", { class: "d-flex form-group align-items-center mb-sm-0" }, [
                        /*#__PURE__*/_createVNode("div", { class: "flex-shrink-0" }, [
                          /*#__PURE__*/_createVNode("label", {
                            for: "Title",
                            class: "mr-3 mb-0"
                          }, "Title")
                        ]),
                        /*#__PURE__*/_createVNode("div", { class: "flex-grow-1" }, [
                          /*#__PURE__*/_createVNode("input", {
                            type: "text",
                            class: "form-control"
                          })
                        ])
                      ])
                    ]),
                    /*#__PURE__*/_createVNode("div", { class: "col-sm-4 col-md-6 text-sm-right" }, [
                      /*#__PURE__*/_createVNode("a", {
                        href: "#",
                        class: "btn default-btn"
                      }, [
                        /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }),
                        /*#__PURE__*/_createTextVNode(" Create Line Item")
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "table-responsive my-2 font-12 border" }, [
                    /*#__PURE__*/_createVNode("table", { class: "table table-borderless mb-0" }, [
                      /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Estimation No"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Description"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Qty"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Unit"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Cost"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Sub Total"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Markup"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Allowance"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Total"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
                        ])
                      ]),
                      /*#__PURE__*/_createVNode("tbody", null, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("select", {
                              name: "",
                              class: "form-control"
                            }, [
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Choose Item"),
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Option 1"),
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Option 2")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn default-btn btn-sm"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("select", {
                              name: "",
                              class: "form-control"
                            }, [
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Choose Item"),
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Option 1"),
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Option 2")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn default-btn btn-sm"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("select", {
                              name: "",
                              class: "form-control"
                            }, [
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Choose Item"),
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Option 1"),
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Option 2")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn default-btn btn-sm"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("select", {
                              name: "",
                              class: "form-control"
                            }, [
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Choose Item"),
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Option 1"),
                              /*#__PURE__*/_createVNode("option", { value: "" }, "Option 2")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("input", {
                              type: "text",
                              class: "form-control"
                            })
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn default-btn btn-sm"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", { class: "border-top" }, [
                          /*#__PURE__*/_createVNode("td", {
                            colspan: "8",
                            class: "text-right"
                          }, [
                            /*#__PURE__*/_createVNode("h6", null, [
                              /*#__PURE__*/_createVNode("strong", null, "Markup")
                            ]),
                            /*#__PURE__*/_createVNode("h6", null, [
                              /*#__PURE__*/_createVNode("strong", null, "Total")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", { colspan: "2" }, [
                            /*#__PURE__*/_createVNode("p", { class: "text-muted" }, [
                              /*#__PURE__*/_createVNode("strong", null, "$0.00")
                            ]),
                            /*#__PURE__*/_createVNode("p", { class: "text-muted" }, [
                              /*#__PURE__*/_createVNode("strong", null, "$0.00")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "table-responsive my-2 font-12 border" }, [
                    /*#__PURE__*/_createVNode("table", { class: "table table-borderless mb-0" }, [
                      /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, [
                            /*#__PURE__*/_createVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createTextVNode(" Estimation No ")
                          ]),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, [
                            /*#__PURE__*/_createVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createTextVNode(" Description")
                          ]),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, [
                            /*#__PURE__*/_createVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createTextVNode(" Qty")
                          ]),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, [
                            /*#__PURE__*/_createVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createTextVNode(" Unit")
                          ]),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, [
                            /*#__PURE__*/_createVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createTextVNode(" Cost")
                          ]),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, [
                            /*#__PURE__*/_createVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createTextVNode(" Sub Total")
                          ]),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, [
                            /*#__PURE__*/_createVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createTextVNode(" Markup")
                          ]),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, [
                            /*#__PURE__*/_createVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createTextVNode(" Allowance")
                          ]),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, [
                            /*#__PURE__*/_createVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createTextVNode(" Total")
                          ])
                        ])
                      ]),
                      /*#__PURE__*/_createVNode("tbody", null, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, " Item No 1 "),
                          /*#__PURE__*/_createVNode("td", null, " Description "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 ")
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, " Item No 1 "),
                          /*#__PURE__*/_createVNode("td", null, " Description "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 ")
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, " Item No 1 "),
                          /*#__PURE__*/_createVNode("td", null, " Description "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 ")
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, " Item No 1 "),
                          /*#__PURE__*/_createVNode("td", null, " Description "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 "),
                          /*#__PURE__*/_createVNode("td", null, " 02 ")
                        ]),
                        /*#__PURE__*/_createVNode("tr", { class: "border-top" }, [
                          /*#__PURE__*/_createVNode("td", {
                            colspan: "8",
                            class: "text-right"
                          }, [
                            /*#__PURE__*/_createVNode("h6", null, [
                              /*#__PURE__*/_createVNode("strong", null, "Markup")
                            ]),
                            /*#__PURE__*/_createVNode("h6", null, [
                              /*#__PURE__*/_createVNode("strong", null, "Total")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("p", { class: "text-muted" }, [
                              /*#__PURE__*/_createVNode("strong", null, "$0.00")
                            ]),
                            /*#__PURE__*/_createVNode("p", { class: "text-muted" }, [
                              /*#__PURE__*/_createVNode("strong", null, "$0.00")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "table-responsive my-2 font-12 border" }, [
                    /*#__PURE__*/_createVNode("table", { class: "table table-borderless mb-0" }, [
                      /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, " Estimation No "),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Status"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Date"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
                        ])
                      ]),
                      /*#__PURE__*/_createVNode("tbody", null, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, " # 17 Job Item Name- Kitchen "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-warning" }, " Pending")
                          ]),
                          /*#__PURE__*/_createVNode("td", null, " 10/20/2022 "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-danger"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" })
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, " # 17 Job Item Name- Kitchen "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-success" }, " Approved")
                          ]),
                          /*#__PURE__*/_createVNode("td", null, " 10/20/2022 "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-danger"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" })
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, " # 17 Job Item Name- Kitchen "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-primary" }, " Draft")
                          ]),
                          /*#__PURE__*/_createVNode("td", null, " 10/20/2022 "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-danger"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" })
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, " # 17 Job Item Name- Kitchen "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-danger" }, " Declined")
                          ]),
                          /*#__PURE__*/_createVNode("td", null, " 10/20/2022 "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-danger"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" })
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, " # 17 Job Item Name- Kitchen "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-info" }, " Created")
                          ]),
                          /*#__PURE__*/_createVNode("td", null, " 10/20/2022 "),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary mr-1"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "#",
                              class: "btn btn-sm text-primary"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "text-end" }, [
                    /*#__PURE__*/_createVNode("div", { class: "inline-items" }, [
                      /*#__PURE__*/_createVNode("ul", null, [
                        /*#__PURE__*/_createVNode("li", null, [
                          /*#__PURE__*/_createVNode("a", {
                            href: "#",
                            class: "btn default-btn"
                          }, "Save")
                        ]),
                        /*#__PURE__*/_createVNode("li", null, [
                          /*#__PURE__*/_createVNode("a", {
                            href: "#",
                            class: "btn default-btn"
                          }, "Save & Send")
                        ]),
                        /*#__PURE__*/_createVNode("li", null, [
                          /*#__PURE__*/_createVNode("a", {
                            href: "#",
                            class: "btn btn-danger px-3"
                          }, "Clear")
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "my-2" }, [
                    /*#__PURE__*/_createVNode("a", {
                      href: "",
                      class: "btn default-btn"
                    }, "Add Company Information")
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "signature-wrap mb-2" }),
                  /*#__PURE__*/_createVNode("p", null, "You can draw /upload Signature in above box"),
                  /*#__PURE__*/_createVNode("div", { class: "inline-items my-2" }, [
                    /*#__PURE__*/_createVNode("ul", null, [
                      /*#__PURE__*/_createVNode("li", null, [
                        /*#__PURE__*/_createVNode("a", {
                          href: "#",
                          class: "btn default-btn"
                        }, "Upload")
                      ]),
                      /*#__PURE__*/_createVNode("li", null, [
                        /*#__PURE__*/_createVNode("a", {
                          href: "#",
                          class: "btn btn-danger px-3"
                        }, "Clear")
                      ]),
                      /*#__PURE__*/_createVNode("li", null, [
                        /*#__PURE__*/_createVNode("a", {
                          href: "#",
                          class: "btn default-btn outline "
                        }, "Cancel")
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
                    /*#__PURE__*/_createVNode("label", { for: "" }, "Note:"),
                    /*#__PURE__*/_createVNode("textarea", {
                      name: "",
                      class: "form-control",
                      rows: "4"
                    })
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
                    /*#__PURE__*/_createVNode("label", { for: "" }, "Customer Emails :"),
                    /*#__PURE__*/_createVNode("input", {
                      type: "text",
                      class: "form-control"
                    })
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "row align-items-center" }, [
                    /*#__PURE__*/_createVNode("div", { class: "col-sm-6" }, [
                      /*#__PURE__*/_createVNode("div", { class: "form-check form-check-inline mb-2" }, [
                        /*#__PURE__*/_createVNode("input", {
                          class: "form-check-input",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createVNode("label", {
                          for: "Approve By All Members",
                          title: "Approve By All Members"
                        }, "Approve By All Members")
                      ])
                    ]),
                    /*#__PURE__*/_createVNode("div", { class: "col-sm-6 text-sm-right" }, [
                      /*#__PURE__*/_createVNode("a", {
                        href: "",
                        class: "btn default-btn"
                      }, "Preview")
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "text-end mt-4" }, [
                    /*#__PURE__*/_createVNode("div", { class: "inline-items" }, [
                      /*#__PURE__*/_createVNode("ul", null, [
                        /*#__PURE__*/_createVNode("li", null, [
                          /*#__PURE__*/_createVNode("a", {
                            href: "#",
                            class: "btn default-btn"
                          }, "Save")
                        ]),
                        /*#__PURE__*/_createVNode("li", null, [
                          /*#__PURE__*/_createVNode("a", {
                            href: "#",
                            class: "btn default-btn"
                          }, "Save & Send")
                        ]),
                        /*#__PURE__*/_createVNode("li", null, [
                          /*#__PURE__*/_createVNode("a", {
                            href: "#",
                            class: "btn btn-danger px-3"
                          }, "Clear")
                        ])
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createVNode("div", {
                  class: "tab-pane fade border-0",
                  id: "v-pills-tab2",
                  role: "tabpanel",
                  "aria-labelledby": "v-pills-tab2-tab"
                }, [
                  /*#__PURE__*/_createVNode("div", { class: "table-responsive my-3 font-12" }, [
                    /*#__PURE__*/_createVNode("table", { class: "table table-bordered table-shadowed mb-0" }, [
                      /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Estimation No"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Status"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
                        ])
                      ]),
                      /*#__PURE__*/_createVNode("tbody", null, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("p", null, [
                              /*#__PURE__*/_createTextVNode("# 324 "),
                              /*#__PURE__*/_createVNode("b", null, "Remodeling"),
                              /*#__PURE__*/_createTextVNode(" Job Estimation")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-primary" }, "Draft")
                          ]),
                          /*#__PURE__*/_createVNode("td", { class: "text-nowrap" }, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm text-primary mr-1",
                              title: "send"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" }),
                              /*#__PURE__*/_createTextVNode(" Send")
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm text-primary mr-1",
                              title: "view details"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }),
                              /*#__PURE__*/_createTextVNode(" Admin Details")
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("p", null, [
                              /*#__PURE__*/_createTextVNode("# 324 "),
                              /*#__PURE__*/_createVNode("b", null, "Remodeling"),
                              /*#__PURE__*/_createTextVNode(" Job Estimation")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-warning" }, "Sent")
                          ]),
                          /*#__PURE__*/_createVNode("td", { class: "text-nowrap" }, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm text-primary mr-1",
                              title: "send"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" }),
                              /*#__PURE__*/_createTextVNode(" Send")
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm text-primary mr-1",
                              title: "view details"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }),
                              /*#__PURE__*/_createTextVNode(" Admin Details")
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("p", null, [
                              /*#__PURE__*/_createTextVNode("# 333 "),
                              /*#__PURE__*/_createVNode("b", null, "Kitchen"),
                              /*#__PURE__*/_createTextVNode(" Job Estimation")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-primary" }, "Draft")
                          ]),
                          /*#__PURE__*/_createVNode("td", { class: "text-nowrap" }, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm text-primary mr-1",
                              title: "send"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" }),
                              /*#__PURE__*/_createTextVNode(" Send")
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm text-primary mr-1",
                              title: "view details"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }),
                              /*#__PURE__*/_createTextVNode(" Admin Details")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "bg-light p-3 rounded border mb-3" }, [
                    /*#__PURE__*/_createVNode("div", { class: "row mx-n2" }, [
                      /*#__PURE__*/_createVNode("div", { class: "col-md-6 col-sm-6 mb-2 px-2" }, [
                        /*#__PURE__*/_createVNode("div", { class: "shadowed-card bg-white h-100 p-3" }, [
                          /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                            /*#__PURE__*/_createVNode("a", {
                              class: "btn default-btn mr-2 btn-sm",
                              title: "Edit",
                              href: "javascript:void(\n                            0)"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-pen" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              class: "btn red-btn btn-sm",
                              title: "Delete",
                              href: "javascript:void(0)"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" })
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("div", { class: "row mx-n2" }, [
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-12 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Enter Email Address"),
                                /*#__PURE__*/_createVNode("p", null, "test.dog24@gmail.com")
                              ])
                            ]),
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-12 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Full Name"),
                                /*#__PURE__*/_createVNode("p", null, "Test")
                              ])
                            ]),
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-6 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Phone Number"),
                                /*#__PURE__*/_createVNode("p")
                              ])
                            ]),
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-6 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Notify By"),
                                /*#__PURE__*/_createVNode("p", null, "Mail ")
                              ])
                            ]),
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-6 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Address"),
                                /*#__PURE__*/_createVNode("p")
                              ])
                            ])
                          ])
                        ])
                      ]),
                      /*#__PURE__*/_createVNode("div", { class: "col-md-6 col-sm-6 mb-2 px-2" }, [
                        /*#__PURE__*/_createVNode("div", { class: "shadowed-card bg-white h-100 p-3" }, [
                          /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                            /*#__PURE__*/_createVNode("a", {
                              class: "btn default-btn mr-2 btn-sm",
                              title: "Edit",
                              href: "javascript:void(\n                            0)"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-pen" })
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              class: "btn red-btn btn-sm",
                              title: "Delete",
                              href: "javascript:void(0)"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" })
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("div", { class: "row mx-n2" }, [
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-12 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Enter Email Address"),
                                /*#__PURE__*/_createVNode("p", null, "test.dog24@gmail.com")
                              ])
                            ]),
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-12 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Full Name"),
                                /*#__PURE__*/_createVNode("p", null, "Test")
                              ])
                            ]),
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-6 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Phone Number"),
                                /*#__PURE__*/_createVNode("p")
                              ])
                            ]),
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-6 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Notify By"),
                                /*#__PURE__*/_createVNode("p", null, "Mail ")
                              ])
                            ]),
                            /*#__PURE__*/_createVNode("div", { class: "col-xl-6 px-2" }, [
                              /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
                                /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fw-600" }, "Address"),
                                /*#__PURE__*/_createVNode("p")
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "row" }, [
                    /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
                      /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
                        /*#__PURE__*/_createVNode("label", { for: "" }, "Project Name"),
                        /*#__PURE__*/_createVNode("input", {
                          type: "text",
                          class: "form-control"
                        })
                      ]),
                      /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
                        /*#__PURE__*/_createVNode("label", { for: "" }, "Total Project Estimation"),
                        /*#__PURE__*/_createVNode("input", {
                          type: "text",
                          class: "form-control"
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
                      /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
                        /*#__PURE__*/_createVNode("label", { for: "" }, "Project Details"),
                        /*#__PURE__*/_createVNode("textarea", {
                          rows: "5",
                          class: "form-control"
                        })
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "row" }, [
                    /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
                      /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
                        /*#__PURE__*/_createVNode("label", { for: "" }, "Project Start Date"),
                        /*#__PURE__*/_createVNode("input", {
                          type: "text",
                          class: "form-control"
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
                      /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
                        /*#__PURE__*/_createVNode("label", { for: "" }, "Project End Date"),
                        /*#__PURE__*/_createVNode("input", {
                          type: "text",
                          class: "form-control"
                        })
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("a", {
                    href: "#",
                    class: "btn default-btn"
                  }, [
                    /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }),
                    /*#__PURE__*/_createTextVNode(" Add Phase")
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "my-3" }, [
                    /*#__PURE__*/_createVNode("a", {
                      href: "#",
                      class: "btn default-btn"
                    }, "Add Company Information")
                  ]),
                  /*#__PURE__*/_createVNode("p", { class: "fw-600" }, "Signature"),
                  /*#__PURE__*/_createVNode("div", { class: "signature-wrap mb-2" }),
                  /*#__PURE__*/_createVNode("a", {
                    href: "#",
                    class: "btn default-btn mb-3"
                  }, "Add New Signature"),
                  /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
                    /*#__PURE__*/_createVNode("label", { for: "" }, "Customer Emails :"),
                    /*#__PURE__*/_createVNode("input", {
                      type: "text",
                      class: "form-control"
                    })
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "row align-items-center" }, [
                    /*#__PURE__*/_createVNode("div", { class: "col-sm-6" }, [
                      /*#__PURE__*/_createVNode("div", { class: "form-check form-check-inline mb-2" }, [
                        /*#__PURE__*/_createVNode("input", {
                          class: "form-check-input",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createVNode("label", {
                          for: "Approve By All Members",
                          title: "Approve By All Members"
                        }, " Approve By All Members ")
                      ])
                    ]),
                    /*#__PURE__*/_createVNode("div", { class: "col-sm-6 text-sm-right" }, [
                      /*#__PURE__*/_createVNode("a", {
                        href: "",
                        class: "btn default-btn"
                      }, "Preview")
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("div", { class: "text-end mt-4" }, [
                    /*#__PURE__*/_createVNode("div", { class: "inline-items" }, [
                      /*#__PURE__*/_createVNode("ul", null, [
                        /*#__PURE__*/_createVNode("li", null, [
                          /*#__PURE__*/_createVNode("a", {
                            href: "#",
                            class: "btn default-btn"
                          }, "Save")
                        ]),
                        /*#__PURE__*/_createVNode("li", null, [
                          /*#__PURE__*/_createVNode("a", {
                            href: "#",
                            class: "btn default-btn"
                          }, "Save & Send")
                        ]),
                        /*#__PURE__*/_createVNode("li", null, [
                          /*#__PURE__*/_createVNode("a", {
                            href: "#",
                            class: "btn btn-danger px-3"
                          }, "Clear")
                        ])
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createVNode("div", {
                  class: "tab-pane fade border-0",
                  id: "v-pills-tab3",
                  role: "tabpanel",
                  "aria-labelledby": "v-pills-tab3-tab"
                }, [
                  /*#__PURE__*/_createVNode("div", { class: "table-responsive my-3 font-12" }, [
                    /*#__PURE__*/_createVNode("table", { class: "table table-bordered table-shadowed mb-0" }, [
                      /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Estimation No"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Status"),
                          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
                        ])
                      ]),
                      /*#__PURE__*/_createVNode("tbody", null, [
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("p", null, [
                              /*#__PURE__*/_createTextVNode("# 324 "),
                              /*#__PURE__*/_createVNode("b", null, "Remodeling"),
                              /*#__PURE__*/_createTextVNode(" Job Estimation")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-success" }, "Approved")
                          ]),
                          /*#__PURE__*/_createVNode("td", { class: "text-nowrap" }, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm text-primary mr-1",
                              title: "view details"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }),
                              /*#__PURE__*/_createTextVNode(" Admin Details")
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm default-btn mr-1 outline"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }),
                              /*#__PURE__*/_createTextVNode(" View Workflow")
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("p", null, [
                              /*#__PURE__*/_createTextVNode("# 324 "),
                              /*#__PURE__*/_createVNode("b", null, "Remodeling"),
                              /*#__PURE__*/_createTextVNode(" Job Estimation")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-success" }, "Approved")
                          ]),
                          /*#__PURE__*/_createVNode("td", { class: "text-nowrap" }, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm text-primary mr-1",
                              title: "view details"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }),
                              /*#__PURE__*/_createTextVNode(" Admin Details")
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm default-btn mr-1 outline"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }),
                              /*#__PURE__*/_createTextVNode(" View Workflow")
                            ])
                          ])
                        ]),
                        /*#__PURE__*/_createVNode("tr", null, [
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("p", null, [
                              /*#__PURE__*/_createTextVNode("# 333 "),
                              /*#__PURE__*/_createVNode("b", null, "Kitchen"),
                              /*#__PURE__*/_createTextVNode(" Job Estimation")
                            ])
                          ]),
                          /*#__PURE__*/_createVNode("td", null, [
                            /*#__PURE__*/_createVNode("span", { class: "badge badge-success" }, "Approved")
                          ]),
                          /*#__PURE__*/_createVNode("td", { class: "text-nowrap" }, [
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm text-primary mr-1",
                              title: "view details"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }),
                              /*#__PURE__*/_createTextVNode(" Admin Details")
                            ]),
                            /*#__PURE__*/_createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn btn-sm default-btn mr-1 outline"
                            }, [
                              /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }),
                              /*#__PURE__*/_createTextVNode(" View Workflow")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createVNode("div", {
                  class: "tab-pane fade border-0",
                  id: "v-pills-tab4",
                  role: "tabpanel",
                  "aria-labelledby": "v-pills-tab4-tab"
                }, " ..."),
                /*#__PURE__*/_createVNode("div", {
                  class: "tab-pane fade border-0",
                  id: "v-pills-tab5",
                  role: "tabpanel",
                  "aria-labelledby": "v-pills-tab5-tab"
                }, " ...")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"offcanvas offcanvas-end\" tabindex=\"-1\" id=\"offcanvasExample\" aria-labelledby=\"offcanvasExampleLabel\"><div class=\"offcanvas-header justify-content-between border-bottom\"><h5 class=\"offcanvas-title\" id=\"offcanvasExampleLabel\">Members</h5><button type=\"button\" class=\"btn-close text-reset\" data-coreui-dismiss=\"offcanvas\" aria-label=\"Close\"></button></div><div class=\"offcanvas-body\"><div class=\"member-list member-chat\"><div class=\"member-fig\"><img src=\"https://lh3.googleusercontent.com/a/AATXAJz9aRPcexlp5gC4xQY_s6VezP2TRg8xQoO2jIGL=s96-c\" alt=\"test.khadka7@gmail.com\" title=\"test.khadka7@gmail.com\"></div><h5>Test Khadka - <span class=\"role-type type-owner\">Todo_payer</span></h5><span class=\"time\"><i class=\"far fa-clock\"></i> Added by Smurfy Basnyat 1 year ago </span><div class=\"my-2\"><a class=\"btn btn-sm default-btn outline mr-2\" href=\"javascript:void(0)\" title=\"Private chat\">Chat <i class=\"far fa-paper-plane\"></i></a></div></div><div class=\"member-list member-chat\"><div class=\"member-fig\"><img src=\"https://lh3.googleusercontent.com/a/AATXAJz9aRPcexlp5gC4xQY_s6VezP2TRg8xQoO2jIGL=s96-c\" alt=\"test.khadka7@gmail.com\" title=\"test.khadka7@gmail.com\"></div><h5>Test Khadka - <span class=\"role-type type-owner\">Todo_payer</span></h5><span class=\"time\"><i class=\"far fa-clock\"></i> Added by Smurfy Basnyat 1 year ago </span><div class=\"my-2\"><a class=\"btn btn-sm default-btn outline mr-2\" href=\"javascript:void(0)\" title=\"Private chat\">Chat <i class=\"far fa-paper-plane\"></i></a></div></div><div class=\"member-list member-chat\"><div class=\"member-fig\"><img src=\"https://lh3.googleusercontent.com/a/AATXAJz9aRPcexlp5gC4xQY_s6VezP2TRg8xQoO2jIGL=s96-c\" alt=\"test.khadka7@gmail.com\" title=\"test.khadka7@gmail.com\"></div><h5>Test Khadka - <span class=\"role-type type-owner\">Todo_payer</span></h5><span class=\"time\"><i class=\"far fa-clock\"></i> Added by Smurfy Basnyat 1 year ago </span><div class=\"my-2\"><a class=\"btn btn-sm default-btn outline mr-2\" href=\"javascript:void(0)\" title=\"Private chat\">Chat <i class=\"far fa-paper-plane\"></i></a></div></div></div></div><div class=\"offcanvas offcanvas-end\" tabindex=\"-1\" id=\"offcanvasExample2\" aria-labelledby=\"offcanvasExample2Label\"><div class=\"offcanvas-header justify-content-between border-bottom\"><h5 class=\"offcanvas-title\" id=\"offcanvasExample2Label\">History</h5><button type=\"button\" class=\"btn-close text-reset\" data-coreui-dismiss=\"offcanvas\" aria-label=\"Close\"></button></div><div class=\"offcanvas-body\"><div class=\"activity-list\"><div class=\"activity-img\"><img src=\"https://app.convorally.com/storage/users/WIN_20240219_10_24_28_Prod1b101b2-7c8f-4487-865b-fc74f9d94af9.jpg\" alt=\"\"></div><p>Smurfy Basnyat Test Dog was added by Smurfy Basnyat in test chat channel for test channel of Complete Flow Project project on June 12,2023 at 8:58 am</p></div><div class=\"activity-list\"><div class=\"activity-img\"><img src=\"https://app.convorally.com/storage/users/WIN_20240219_10_24_28_Prod1b101b2-7c8f-4487-865b-fc74f9d94af9.jpg\" alt=\"\"></div><p>Smurfy Basnyat Test Dog was added by Smurfy Basnyat in test chat channel for test channel of Complete Flow Project project on June 12,2023 at 8:58 am</p></div><div class=\"activity-list\"><div class=\"activity-img\"><img src=\"https://app.convorally.com/storage/users/WIN_20240219_10_24_28_Prod1b101b2-7c8f-4487-865b-fc74f9d94af9.jpg\" alt=\"\"></div><p>Smurfy Basnyat Test Dog was added by Smurfy Basnyat in test chat channel for test channel of Complete Flow Project project on June 12,2023 at 8:58 am</p></div></div></div><div class=\"offcanvas offcanvas-end\" tabindex=\"-1\" id=\"offcanvasExample3\" aria-labelledby=\"offcanvasExample3Label\"><div class=\"offcanvas-header justify-content-between border-bottom\"><h5 class=\"offcanvas-title\" id=\"offcanvasExample3Label\">Latest Forms</h5><button type=\"button\" class=\"btn-close text-reset\" data-coreui-dismiss=\"offcanvas\" aria-label=\"Close\"></button></div><div class=\"offcanvas-body\"><div class=\"form-list-card d-flex gap-3 mb-3\"><div class=\"flex-shrink-0\"><i class=\"fa fa-file-alt fa-2x text-green\"></i></div><div class=\"flex-grow-1\"><h6 class=\"mb-0 fw-600\">Contract Clean For Remodeling</h6><p class=\"fs-12\"><i class=\"fa fa-calendar-week mr-1 text-black\"></i> <span>2022-02-11T01:39:17.038Z</span></p></div></div><div class=\"form-list-card d-flex gap-3 mb-3\"><div class=\"flex-shrink-0\"><i class=\"fa fa-file-alt fa-2x text-green\"></i></div><div class=\"flex-grow-1\"><h6 class=\"mb-0 fw-600\">Contract Clean For Remodeling</h6><p class=\"fs-12\"><i class=\"fa fa-calendar-week mr-1 text-black\"></i> <span>2022-02-11T01:39:17.038Z</span></p></div></div><div class=\"form-list-card d-flex gap-3 mb-3\"><div class=\"flex-shrink-0\"><i class=\"fa fa-file-alt fa-2x text-green\"></i></div><div class=\"flex-grow-1\"><h6 class=\"mb-0 fw-600\">Contract Clean For Remodeling</h6><p class=\"fs-12\"><i class=\"fa fa-calendar-week mr-1 text-black\"></i> <span>2022-02-11T01:39:17.038Z</span></p></div></div></div></div><div class=\"offcanvas offcanvas-end\" tabindex=\"-1\" id=\"offcanvasExample4\" aria-labelledby=\"offcanvasExample4Label\"><div class=\"offcanvas-header justify-content-between border-bottom\"><h5 class=\"offcanvas-title\" id=\"offcanvasExample4Label\">Share Members</h5><button type=\"button\" class=\"btn-close text-reset\" data-coreui-dismiss=\"offcanvas\" aria-label=\"Close\"></button></div><div class=\"offcanvas-body px-0\"><div class=\"mb-3 px-3\"><a href=\"#\" class=\"btn default-btn outline\">Add Share Project</a></div><div class=\"table-responsive\"><table class=\"table table-borderless mb-0 font-12\"><thead class=\"table-light\"><tr><td>Email</td><td>Status</td><td>Action</td></tr></thead><tbody><tr><td>steve@gmail.com</td><td><span class=\"text-warning\">Pending</span></td><td><a class=\"btn default-btn mr-2 btn-sm\" title=\"Edit\" href=\"javascript:void(\n                            0)\"><i class=\"fa fa-pen\"></i></a><a class=\"btn red-btn btn-sm\" title=\"Delete\" href=\"javascript:void(0)\"><i class=\"far fa-trash-alt\"></i></a></td></tr><tr><td>steve@gmail.com</td><td><span class=\"text-warning\">Pending</span></td><td><a class=\"btn default-btn mr-2 btn-sm\" title=\"Edit\" href=\"javascript:void(\n                            0)\"><i class=\"fa fa-pen\"></i></a><a class=\"btn red-btn btn-sm\" title=\"Delete\" href=\"javascript:void(0)\"><i class=\"far fa-trash-alt\"></i></a></td></tr><tr><td>steve@gmail.com</td><td><span class=\"text-warning\">Pending</span></td><td><a class=\"btn default-btn mr-2 btn-sm\" title=\"Edit\" href=\"javascript:void(\n                            0)\"><i class=\"fa fa-pen\"></i></a><a class=\"btn red-btn btn-sm\" title=\"Delete\" href=\"javascript:void(0)\"><i class=\"far fa-trash-alt\"></i></a></td></tr></tbody></table></div><div class=\"px-3 pt-3 border-top\"><p class=\"text-muted\">Showing 3 of 10 Results</p></div></div></div>", 4)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3
  ]))
}